import api from "./api";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const useReportes = () => {
  const { Token } = useUserSuperEmpresa();

  const getReporteIngreso = async (params = {}) => {
    try {
      const response = await api.post(
        "/reports/export/income",
        { params }, // Incluye month, year, branch_id y format
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          responseType: "blob", // Para recibir archivo binario (PDF o Excel)
        }
      );
      return response.data; // Blob del archivo
    } catch (error) {
      throw error.response?.data?.message || "Error al Descargar";
    }
  };

  return { getReporteIngreso };
};